export class EmailVerifiedRequest {
    email: string;
}